import React, {FC} from "react";
import Button from "@material-ui/core/Button";
import {OrderEngineStepperActionsProps} from "../types";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        }
    }),
);

export const OrderEngineStepActions: FC<OrderEngineStepperActionsProps> = ({
                                                                               onClickNext,
                                                                               onClickBack,
                                                                               lastStep
                                                                           }) => {
    const classes = useStyles();
    return (
        <div className={classes.actionsContainer}>
            <div>
                <Button
                    disabled={!onClickBack}
                    onClick={onClickBack}
                    variant="outlined"
                    className={classes.button}
                >
                    zurück
                </Button>
                <Button
                    variant="contained"
                    disabled={!onClickNext}
                    color="primary"
                    onClick={onClickNext}
                    className={classes.button}
                >
                    {lastStep ? 'Jetzt Buchen' : 'weiter'}
                </Button>
            </div>
        </div>
    )
}